"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSetAuthorized = exports.useIsAuthorized = void 0;
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var useCache_1 = require("../useCache");
var react_1 = require("react");
var AUTH_STATE = 'auth_state';
var useIsAuthorized = function () {
    var data = (0, useQuery_1.useQuery)({
        path: keys_1.USER,
        revalidateOnMount: true,
        shouldRetryOnError: false,
    }).data;
    var _a = (0, useCache_1.useCache)(), getDataFromCache = _a.getDataFromCache, setDataToCache = _a.setDataToCache;
    var isAuthState = getDataFromCache(AUTH_STATE);
    (0, react_1.useEffect)(function () {
        if (!isAuthState && !!data)
            setDataToCache(AUTH_STATE, true);
    }, [setDataToCache, isAuthState, data]);
    return isAuthState || !!data;
};
exports.useIsAuthorized = useIsAuthorized;
var useSetAuthorized = function () {
    var setDataToCache = (0, useCache_1.useCache)().setDataToCache;
    return (0, react_1.useCallback)(function (state) {
        setDataToCache(AUTH_STATE, state);
    }, [setDataToCache]);
};
exports.useSetAuthorized = useSetAuthorized;
